export enum CueDropzone {
  GROUP = 'group',
  CUE = 'cue',
  BEFORE = 'before',
  AFTER = 'after',
}

export const DroppableId = {
  [CueDropzone.GROUP]: (cueId: string) => `${CueDropzone.GROUP}-${cueId}`,
  [CueDropzone.CUE]: (cueId: string) => `${CueDropzone.CUE}-${cueId}`,
  [CueDropzone.BEFORE]: (cueId: string) => `${CueDropzone.BEFORE}-${cueId}`,
  [CueDropzone.AFTER]: (cueId: string) => `${CueDropzone.AFTER}-${cueId}`,
}

export const getCueDropzone = (
  droppableId: string,
): CueDropzone | undefined => {
  const [type] = droppableId.split('-')

  if (!Object.values(CueDropzone).includes(type as CueDropzone)) return

  return type as CueDropzone
}

export const getIsGrouping = (droppableId: string): boolean => {
  const type = getCueDropzone(droppableId)

  return type === CueDropzone.CUE || type === CueDropzone.GROUP
}

export const getTargetCueId = (droppableId: string): string | undefined => {
  const [, cueId] = droppableId.split('-', 2)

  return cueId || undefined
}
